export default "__VITE_ASSET__2fa4caca__"